import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mantine/core';

import { hasGeom } from 'util/field';
import { RootState } from 'store';
import { FieldType } from 'store/fields/types';
import { userCanEditPlans } from 'store/user/selectors';

type StatusPropsType = {
  field: FieldType;
};

const OrderPlanButton = ({ field }: StatusPropsType) => {
  const navigate = useNavigate();
  const fieldProps = field.features[0].properties;
  const { t } = useTranslation();

  const { userCanEdit, operation } = useSelector((state: RootState) => ({
    userCanEdit: userCanEditPlans(state, fieldProps.operation_id),
    operation: state.operations.operationsById[fieldProps.operation_id],
  }));

  return (
    <>
      {hasGeom(field) ? (
        <Button
          size="compact-md"
          disabled={!userCanEdit || !operation?.billing_user_id}
          onClick={() => {
            navigate(`/zone-analysis/${fieldProps.operation_id}/${fieldProps.id}`);
          }}
        >
          {t('orderSampling')}
        </Button>
      ) : (
        <Button
          size="compact-md"
          onClick={() => {
            navigate(`/field-boundary/${fieldProps.operation_id}/${fieldProps.id}`);
          }}
        >
          {t('editFieldBoundary')}
        </Button>
      )}
    </>
  );
};

export default OrderPlanButton;
